import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Popover } from 'react-bootstrap-5';

import './styles.scss';

const planTypes = [
  {
    type: `Broker's Gross (Plan Commissions Only)`,
    description: `A broker's commission tier is determined by totaling the gross commissions brought in by the broker
    and paid under this commission plan.`
  },
  {
    type: `Broker's Gross (All Commissions)`,
    description: `A broker's commission tier is determined by totaling the gross commissions brought in by the broker
    across all deals, paid under any plan or no plan. `
  },
  {
    type: `Broker's Split (Plan Commissions Only)`,
    description: `A broker's commission tier is determined by totaling the broker's split (broker's gross less house
    split) of commissions paid under this commission plan.`
  },
  {
    type: `Broker's Split (All Commissions)`,
    description: `A broker's commission tier is determined by totaling the broker's split (broker's gross less house
    split) across all deals, paid under any plan or no plan.`
  },
];

export function PlanInformation() {
  const renderPlanTypes = () => (
    planTypes.map((plan, i) => (
      <li className="mb-3" key={i}>
        <div className="mb-1"><strong>{plan.type}</strong></div>
        <div>{plan.description}</div>
      </li>
    ))
  );

  const tooltip = (
    <Popover className="plan-information-tooltip p-4" id="plan-information-tooltip">
      <h6 className="mb-3">Plan Types</h6>

      <ul>{renderPlanTypes()}</ul>

      For more information on commission plans, see the&nbsp;
      <a
        href="https://help.buildout.com/en/articles/7919986-choosing-the-right-commission-plan-type"
        rel="noopener noreferrer"
        target="_blank"
      >
        Help Center
      </a>.
    </Popover>
  );

  return (
    <OverlayTrigger overlay={tooltip} placement="bottom" rootClose trigger="click">
      <FontAwesomeIcon className="text-muted clickable ms-3" icon={faInfoCircle} />
    </OverlayTrigger>
  );
}

export default PlanInformation;
